import './Orders.css'

export default function Orders(props) {

    return (
        <div>
            <h1>Orders</h1>
        </div>
    )
}